import { Link } from "react-router-dom";
import {
  ArrowRightIcon,
  ArrowUpRightIcon,
  PlayIcon,
  CheckIcon,
  BookOpenIcon,
  ChartBarIcon,
  SparklesIcon,
  CodeBracketIcon,
} from "@heroicons/react/24/outline";
import Navbar from "../../Components/Navbar/Navbar";
import CoursesPage from "../../Components/Courses/CoursesPage";
import { signInWithGoogle } from "../../apis/Signin";
import { getUser } from "../../services/Authservice";

export default function LandingHomePage({ welcome = false }) {
  const user = getUser();
  return (
    <>
      <Navbar />
      <main id="main-content">
        <section className="page-width hero">
          <div className="hero-copy">
            <p className="eyebrow">
              <span className="status-dot" /> A LITTLE FOCUS. A LOT OF
              POSSIBILITIES.
            </p>
            <h1>
              Big ambitions.
              <br />
              Small steps.
              <br />
              <span>Your own pace.</span>
            </h1>
            <p className="hero-description">
              Your next chapter starts with a little curiosity. Discover free
              courses, keep your notes close, and turn learning into a habit.
            </p>
            <div className="hero-actions">
              <a className="button button-primary" href="#courses">
                Explore courses <ArrowRightIcon />
              </a>
              {user ? (
                <Link className="button button-secondary" to="/dashboard">
                  My learning <ArrowUpRightIcon />
                </Link>
              ) : (
                <button
                  className="button button-secondary"
                  onClick={signInWithGoogle}
                >
                  <span className="google-mark" aria-hidden="true">
                    G
                  </span>{" "}
                  Continue with Google
                </button>
              )}
            </div>
            <p className="hero-note">
              <CheckIcon /> Free to learn. A space to focus.
            </p>
            {welcome && (
              <p className="signin-hint">
                Sign in to save courses and pick up where you left off.
              </p>
            )}
          </div>
          <div
            className="learning-preview"
            aria-label="A preview of focused learning on Saarthi"
          >
            <div className="preview-top">
              <span>
                <i />
                <i />
                <i />
              </span>
              <span>YOUR SPACE TO GROW</span>
              <SparklesIcon />
            </div>
            <div className="preview-content">
              <div className="preview-label">
                <span className="small-tag">THE LEARNING MINDSET</span>
                <span>01 / 03</span>
              </div>
              <div className="code-art">
                <div className="code-orbit orbit-one" />
                <div className="code-orbit orbit-two" />
                <CodeBracketIcon />
                <span className="code-spark spark-one">+</span>
                <span className="code-spark spark-two">✦</span>
              </div>
              <h2>A little better, every day.</h2>
              <p>One lesson. One idea. One step forward.</p>
              <div className="preview-timeline">
                <span />
                <span />
                <span />
              </div>
              <div className="lesson-row">
                <span className="lesson-number complete">
                  <CheckIcon />
                </span>
                <span>
                  Follow your curiosity
                  <small>Find something you want to learn</small>
                </span>
                <CheckIcon />
              </div>
              <div className="lesson-row current">
                <span className="lesson-number">
                  <PlayIcon />
                </span>
                <span>
                  Make room for focus
                  <small>Less noise. More understanding.</small>
                </span>
                <span className="now-tag">YOU’RE HERE</span>
              </div>
              <div className="lesson-row">
                <span className="lesson-number">03</span>
                <span>
                  Keep moving forward
                  <small>Build a habit, at your own pace</small>
                </span>
              </div>
            </div>
            <div className="focus-badge">
              <span>
                <SparklesIcon />
              </span>
              <div>
                A clearer path.<small>From curious to confident.</small>
              </div>
            </div>
          </div>
        </section>
        <section
          className="page-width benefit-strip"
          aria-label="Why learn with Saarthi"
        >
          <div>
            <PlayIcon />
            <span>
              Less distraction
              <small>Stay with the lesson, in a focused player</small>
            </span>
          </div>
          <div>
            <ChartBarIcon />
            <span>
              Progress that stays with you
              <small>Save courses and track every step</small>
            </span>
          </div>
          <div>
            <BookOpenIcon />
            <span>
              Better together
              <small>Learn from notes shared by the community</small>
            </span>
          </div>
        </section>
        <CoursesPage />
        <section className="page-width notes-banner">
          <div>
            <p className="eyebrow">GOOD NOTES GO A LONG WAY</p>
            <h2>A new perspective is a page away.</h2>
            <p>
              Explore the community’s notes. Share a little of what you know.
            </p>
          </div>
          <Link className="button button-secondary" to="/notes">
            Explore notes <ArrowUpRightIcon />
          </Link>
        </section>
      </main>
      <footer className="page-width site-footer">
        <Link className="brand" to="/">
          saarthi<span>.</span>
        </Link>
        <p>A companion for your learning journey.</p>
        <span>Stay curious. Keep growing.</span>
      </footer>
    </>
  );
}
